import { Icons, Progress, Text, defaultTheme } from '@agro-club/agroclub-shared'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'
import { DealStatus, DealStatusTypes } from 'modules/domain/deal/types'
import { FC, ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import { useDealContext } from 'views/pages/Deal/DealDetail/DealContext'
import { StatusBlockWrapper } from '../../styled/common'
import { AButton } from '../Analytics'
import AMobileButton from '../Analytics/AMobileButton'
import { StatusesRightArrow } from '../StatusesRightArrow/StatusesRightArrow'
import { DealStatusModal, DealStatusModalProps } from './DealStatusModal/DealStatusModal'
import { DealValidationErrors } from './DealStatusModal/DealValidationInfo'
import { ToNewModal } from './ToNewModal'
import { InProgressModal } from './InProgressModal'

const ValidationWrapper = styled.div`
  display: flex;
`
export type DealStatusButtonProps = Omit<DealStatusModalProps, 'onClose'> & {
  canMoveNextStatus: boolean
}

export type ChangeDealStatusProps = {
  changeStatusAction: (id?: string | undefined, _status?: string | undefined) => Promise<unknown>
  nextStatus?: DealStatusButtonProps['nextStatus']
  changeStatusProgress: Progress
  currentStatus: DealStatus
}

export const ChangeDealStatus: FC<ChangeDealStatusProps> = (props) => {
  const { deal } = useDealContext()
  const { nextStatus, currentStatus } = props
  const { t } = useTranslation('logistics')

  const canMoveNextStatus = !Object.values(deal.next_status_validation).some((v) => v.missing)
  const [isConfirmVisible, setConfirmVisible] = useState<boolean>(false)

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  const changeDealStatusHandler = () => {
    if (nextStatus?.slug) {
      return props.changeStatusAction(deal.id, nextStatus.slug)
    }
  }
  const onModalClose = () => setConfirmVisible(false)

  let modalJSX: ReactNode = null
  if (isConfirmVisible) {
    if (nextStatus?.slug === DealStatusTypes.IN_PROGRESS) {
      modalJSX = (
        <InProgressModal
          onClose={onModalClose}
          changeDealStatusHandler={changeDealStatusHandler}
          //changeDealStatusProgress={props.changeStatusProgress}
        />
      )
    } else if (nextStatus?.slug === DealStatusTypes.NEW) {
      modalJSX = (
        <ToNewModal
          dealId={parseInt(deal.id)}
          customerCompanyId={deal.purchase_bid.company.id as any} // should be number here
          customerAddress={deal.purchase_bid.address}
          onClose={onModalClose}
          changeDealStatusHandler={changeDealStatusHandler}
          has_filled_unload_address_params={deal.has_filled_unload_address_params}
        />
      )
    } else if (nextStatus) {
      modalJSX = <DealStatusModal onClose={onModalClose} nextStatus={nextStatus} dealId={deal.id} {...props} />
    }
  }

  return (
    <>
      {!isMobile ? (
        <StatusBlockWrapper>
          <Text color="secondary" typography="buttonLarge">
            {t('common:status')}: {capitalizeFirstLetter(currentStatus?.label)}
          </Text>
          {nextStatus && !deal.is_position && (
            <>
              <StatusesRightArrow />
              <ValidationWrapper>
                {!canMoveNextStatus && <DealValidationErrors validationInfo={deal.next_status_validation} />}
                <>
                  <AButton
                    onClick={() => setConfirmVisible(true)}
                    disabled={!canMoveNextStatus}
                    id={nextStatus.slug}
                    color="secondary"
                    size="medium"
                  >
                    {capitalizeFirstLetter(nextStatus.label)}
                  </AButton>
                </>
              </ValidationWrapper>
            </>
          )}
        </StatusBlockWrapper>
      ) : (
        nextStatus && (
          <AMobileButton
            onClick={() => setConfirmVisible(true)}
            disabled={!canMoveNextStatus}
            Icon={Icons.IconArrowRightM}
            id={nextStatus.slug}
            color="secondary"
          >
            {capitalizeFirstLetter(nextStatus.label)}
          </AMobileButton>
        )
      )}
      {modalJSX}
    </>
  )
}
